import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Autocomplete, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Menu from '@mui/material/Menu';
import { CloudUpload as CloudUploadIcon, Close as CloseIcon } from '@mui/icons-material';
import axios from 'axios';
import AWS from 'aws-sdk';
import { BASE_URL } from '../../components/CommonExport';
import './topics.css';

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;

const ActionMenu = ({ params, setEditFormData, setEditingId, setModalEdit, setDeleteModal, getTags, getPlayingEleven}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} color="inherit">
                <MoreVertIcon />
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => {
                    getTags();
                    getPlayingEleven();
                    setEditFormData({
                        title: params.row.title,
                        tags: params.row.tags,
                        match_id: params.row.match_id,
                        player_id: params.row.player_id,
                        media: params.row.media,
                        priority: params.row.priority
                    });
                    setEditingId(Number(params.row.id));
                    setModalEdit(true);
                    handleClose();
                }}>Edit</MenuItem>
                <MenuItem onClick={() => {
                    setEditingId(Number(params.row.id));
                    setDeleteModal(true);
                    handleClose();
                }}>Delete</MenuItem>
            </Menu>
        </div>
    );
};

const Topics = () => {
    const [modal, setModal] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [tags, setTags] = useState([]);
    const [playingEleven, setPlayingEleven] = useState([]);
    const [loading, setLoading] = useState(false);
    const [s3Url, setS3Url] = useState('');
    const addFileInputRef = useRef(null);
    const editFileInputRef = useRef(null);
    const matches = useSelector((state) => state.matchReducer.matches);
    const match_id = matches.match_id;
    const [formData, setFormData] = useState({
        title: '',
        tags: [],
        match_id: match_id || 0,
        player_id: 0,
        media: '',
        priority: 0
    });
    const [editFormData, setEditFormData] = useState({
        match_id: match_id || 0
    });
    const [topicsData, setTopicsData] = useState([]);
    const [tagStats, setTagStats] = useState([]);
    const [showAllStats, setShowAllStats] = useState(false);
    const [selectedPlayerId, setSelectedPlayerId] = useState(null);
    const [playerOptions, setPlayerOptions] = useState([]);

    const toggle = () => {
        setModal(!modal);
        setFormData({
            title: '',
            tags: [],
            match_id: match_id || 0,
            player_id: null,
            media: '',
            priority: 0
        });
        getTags();
        getPlayingEleven();
    };

    const handleChange = (event, field) => {
        const value = event.target.value;
        if (modalEdit) {
            setEditFormData({ ...editFormData, [field]: value || null });
        } else {
            setFormData({ ...formData, [field]: value || null });
        }
        console.log('this is the edit form data', editFormData);
        console.log('this is the form data', formData);
    };

    const handleFileUpload = async (event, isEdit = false) => {
        const s3 = new AWS.S3({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_ACCESS_KEY,
            region: REGION,
        });
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        const fileNameParts = file.name.split('.');
        const fileExtension = fileNameParts.length > 1 ? `.${fileNameParts.pop()}` : '';
        const fileNameWithoutExtension = fileNameParts.join('.');
        const params = {
            Bucket: S3_BUCKET,
            Key: `topics/${fileNameWithoutExtension}_${Date.now()}${fileExtension}`,
            Body: file,
            ContentType: file.type,
        };

        try {
            const uploadResponse = await s3.upload(params).promise();
            const uploadedUrl = uploadResponse.Location;
            setS3Url(uploadedUrl);
            if (isEdit) {
                setEditFormData({ ...editFormData, media: uploadedUrl });
            } else {
                setFormData({ ...formData, media: uploadedUrl });
            }
            console.log('this is the form data', formData);
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);
        }
    };

    const deleteUploadedFile = async (isEdit = false) => {
        if (!s3Url) return;

        const s3 = new AWS.S3({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_ACCESS_KEY,
            region: REGION,
        });

        const fileName = s3Url.split('/').pop();
        const params = {
            Bucket: S3_BUCKET,
            Key: `topics/${fileName}`,
        };

        try {
            await s3.deleteObject(params).promise();
            setS3Url('');
            if (isEdit) {
                if (editFileInputRef.current) {
                    editFileInputRef.current.value = '';
                }
                setEditFormData({ ...editFormData, media: '' });
            } else {
                if (addFileInputRef.current) {
                    addFileInputRef.current.value = '';
                }
                setFormData({ ...formData, media: '' });
            }
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };

    const getTags = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/admin/tags/get_tags`);
            setTags(response.data.data);
        } catch (error) {
            console.error('Error fetching tags:', error);
        }
    };

    const getPlayingEleven = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/players/playing-eleven/${match_id}`);
            setPlayingEleven(response.data.data.playingEleven || []);
            console.log('this is the playing eleven', playingEleven);
        } catch (err) {
            console.log(err);
        }
    }

    const getPlayingElevenForFilter = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/players/playing-eleven/${match_id}`);
            const formattedPlayers = response.data.data.playingEleven.map(player => ({
                label: player.name,
                value: player.player_id
            }));
            setPlayerOptions(formattedPlayers);
        } catch (err) {
            console.log(err);
        }
    }

    const getTopics = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/admin/topics/${match_id}`);
            console.log('this is the response', response.data.data.topics);
            setTopicsData(response.data.data.topics);
            console.log('this is the topics data', topicsData);
        } catch (error) {
            console.error('Error fetching topics:', error);
        }
    };

    const addTopic = async () => {
        try {
            await axios.post(`${BASE_URL}/admin/topics/add`, formData);
            getTopics();
            toggle();
        } catch (error) {
            console.error('Error adding topic:', error);
        }
    };

    const editTopic = async () => {
        try {
            await axios.put(`${BASE_URL}/admin/topics/update/${editingId}`, editFormData);
            getTopics();
            setModalEdit(false);
        } catch (error) {
            console.error('Error editing topic:', error);
        }
    };

    const deleteTopic = async () => {
        try {
            await axios.delete(`${BASE_URL}/admin/topics/delete/${editingId}`);
            getTopics();
            setDeleteModal(false);
        } catch (error) {
            console.error('Error deleting topic:', error);
        }
    };

    const handlePublishToggle = async (topicId, currentStatus) => {
        try {
            await axios.post(`${BASE_URL}/admin/topics/${currentStatus ? 'unpublish' : 'publish'}/${topicId}`);
            getTopics(); // Refresh the topics list
        } catch (error) {
            console.error('Error toggling publish status:', error);
        }
    };

    const getTagStats = async () => {
        try {
            const params = new URLSearchParams();
            if (selectedPlayerId) {
                params.append('player_id', selectedPlayerId);
            }
            const response = await axios.get(`${BASE_URL}/admin/topics/top-tags/${match_id}?${params.toString()}`);
            console.log('this is the response', response.data.data.tags);
            setTagStats(response.data.data.tags || []);
        } catch (error) {
            console.error('Error fetching tag stats:', error);
        }
    };

    useEffect(() => {
        getTopics();
    }, []);

    useEffect(() => {
        getTagStats();
    }, [selectedPlayerId]);

    const displayedStats = showAllStats ? tagStats : tagStats.slice(0, 3);

    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'title', headerName: 'Title', width: 200 },
        { field: 'tags', headerName: 'Tags', width: 200, renderCell: (params) => (
            <div>
                {params.row.tags.map((tag) => (
                    <span key={tag.id}>{tag.tag} </span>
                ))}
            </div>
        )},
        { field: 'player_name', headerName: 'Player Name', width: 100 },
        { field: 'priority', headerName: 'Priority', width: 100 },
        {
            field: 'publish',
            headerName: 'Publish/Unpublish',
            width: 140,
            renderCell: (params) => (
                <Button
                    color={params.row.status ? 'secondary' : 'primary'}
                    onClick={() => handlePublishToggle(params.row.id, params.row.status)}
                >
                    {params.row.status ? 'Unpublish' : 'Publish'}
                </Button>
            ),
        },
        {
            field: 'media',
            headerName: 'Media',
            width: 100,
            renderCell: (params) => (
                <Box
                    sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '50%',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5'
                    }}
                >
                    <img 
                        src={params.row.media} 
                        alt="Topic Media" 
                        style={{ 
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }} 
                    />
                </Box>
            ),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            renderCell: (params) => (
                <ActionMenu
                    params={params}
                    setEditFormData={setEditFormData}
                    setEditingId={setEditingId}
                    setModalEdit={setModalEdit}
                    setDeleteModal={setDeleteModal}
                    getTags={getTags}
                    getPlayingEleven={getPlayingEleven}
                />
            ),
        },
    ];

    return (
        <div className="topics-container">
            <h3 style={{ marginBottom: '16px', fontSize: '1.1rem', fontWeight: 'normal' }}>Trending Tags(last 24 hours)</h3>
            <Box sx={{ mb: 2 }}>
                <Autocomplete
                    options={playerOptions}
                    getOptionLabel={(option) => option.label}
                    value={playerOptions.find(option => option.value === selectedPlayerId) || null}
                    onChange={async (event, newValue) => {
                        await getPlayingElevenForFilter();
                        setSelectedPlayerId(newValue ? newValue.value : null);
                    }}
                    onOpen={async () => {
                        await getPlayingElevenForFilter();
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label="Filter by Player" fullWidth />
                    )}
                    sx={{ maxWidth: 300 }}
                />
            </Box>
            <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tag</TableCell>
                            <TableCell align="right">Posts</TableCell>
                            <TableCell align="right">Views</TableCell>
                            <TableCell align="right">Likes</TableCell>
                            <TableCell align="right">Comments</TableCell>
                            <TableCell>Top Player</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedStats.map((stat) => (
                            <TableRow key={stat.tag}>
                                <TableCell>{stat.tag}</TableCell>
                                <TableCell align="right">{stat.post_count}</TableCell>
                                <TableCell align="right">{stat.view_count}</TableCell>
                                <TableCell align="right">{stat.like_count}</TableCell>
                                <TableCell align="right">{stat.comment_count}</TableCell>
                                <TableCell>{stat.top_player}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {tagStats.length > 3 && (
                <Box display="flex" justifyContent="center" mb={2}>
                    <IconButton 
                        size="small"
                        onClick={() => setShowAllStats(!showAllStats)}
                        sx={{ 
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.08)'
                            }
                        }}
                    >
                        {showAllStats ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </Box>
            )}

            <Button color="primary" onClick={toggle}>Add Topic</Button>

            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Add Topic</ModalHeader>
                <ModalBody>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Title"
                                value={formData.title}
                                onChange={(e) => handleChange(e, 'title')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                multiple
                                options={tags}
                                getOptionLabel={(option) => option.tag}
                                value={formData.tags}
                                onChange={(event, newValue) => {
                                    const selectedTags = newValue.map(tag => ({
                                        id: tag.id,
                                        tag: tag.tag
                                    }));
                                    setFormData({ ...formData, tags: selectedTags });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Tags" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={playingEleven}
                                getOptionLabel={(option) => option.name}
                                value={playingEleven.find(player => Number(player.player_id) === Number(formData.player_id)) || null}
                                onChange={(event, newValue) => {
                                    setFormData({ ...formData, player_id: newValue ? newValue.player_id : 0 });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Player" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <input
                                accept="image/*"
                                id="upload-media"
                                type="file"
                                ref={addFileInputRef}
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileUpload(e, false)}
                            />
                            <label htmlFor="upload-media" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    disabled={loading}
                                    onClick={() => addFileInputRef.current?.click()}
                                    size="small"
                                    sx={{ 
                                        minWidth: '120px',
                                        height: '36px',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    Upload Media
                                </Button>
                                {formData.media && (
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={formData.media}
                                            alt="uploaded media preview"
                                            style={{ width: '50px', height: '50px', borderRadius: '4px' }}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={() => deleteUploadedFile(false)}
                                            style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}
                            </label>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Priority"
                                value={formData.priority}
                                onChange={(e) => handleChange(e, 'priority')}
                            />
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={addTopic}>Add</Button>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalEdit} toggle={() => setModalEdit(false)}>
                <ModalHeader toggle={() => setModalEdit(false)}>Edit Topic</ModalHeader>
                <ModalBody>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Title"
                                value={editFormData.title}
                                onChange={(e) => handleChange(e, 'title')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={playingEleven}
                                getOptionLabel={(option) => option.name}
                                value={playingEleven.find(player => Number(player.player_id) === Number(editFormData.player_id)) || null}
                                onChange={(event, newValue) => {
                                    setEditFormData({ ...editFormData, player_id: newValue ? newValue.player_id : 0 })
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Player" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <input
                                accept="image/*"
                                id="edit-upload-media"
                                type="file"
                                ref={editFileInputRef}
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileUpload(e, true)}
                            />
                            <label htmlFor="edit-upload-media" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    disabled={loading}
                                    onClick={() => editFileInputRef.current?.click()}
                                    size="small"
                                    sx={{ 
                                        minWidth: '120px',
                                        height: '36px',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    Upload Media
                                </Button>
                                {editFormData.media && (
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={editFormData.media}
                                            alt="uploaded media preview"
                                            style={{ width: '50px', height: '50px', borderRadius: '4px' }}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={() => deleteUploadedFile(true)}
                                            style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}
                            </label>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Priority"
                                value={editFormData.priority}
                                onChange={(e) => handleChange(e, 'priority')}
                            />
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={editTopic}>Save</Button>
                    <Button color="secondary" onClick={() => setModalEdit(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
                <ModalHeader toggle={() => setDeleteModal(false)}>Delete Topic</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this topic?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={deleteTopic}>Delete</Button>
                    <Button color="secondary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <div style={{ height: 400, width: '100%', marginTop: '20px' }}>
                <DataGrid
                    rows={topicsData}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                />
            </div>
        </div>
    );
};

export default Topics;
